import { render } from "./Arts.vue?vue&type=template&id=b5d27644&scoped=true"
import script from "./Arts.vue?vue&type=script&lang=js"
export * from "./Arts.vue?vue&type=script&lang=js"

import "./Arts.vue?vue&type=style&index=0&id=b5d27644&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b5d27644"

export default script